import React from 'react';

import { Tiptap, tipTapPluginsMode } from 'widgets/TipTap';

type WidgetTipTapProps = {
  id?: string;
  value?: string;
  onChange: (value: string) => void;
};

export class WidgetTipTap extends React.Component<WidgetTipTapProps> {
  state = {};

  onChange = (value) => {
    const { onChange } = this.props;

    this.setState({ value });
    onChange(value);
  };

  render() {
    const { value, id } = this.props;

    return (
      <div data-testid={id}>
        <Tiptap
          content={value || ''}
          onChange={this.onChange}
          pluginsMode={tipTapPluginsMode.all}
          isRichText
          isHtmlMode
        />
      </div>
    );
  }
}
